import Anthropic from '@anthropic-ai/sdk';

/**
 * Initializes the Anthropic Claude client with the API key from environment variables.
 * @returns {Anthropic} Configured Anthropic client instance.
 */
const claude = new Anthropic({
  apiKey: import.meta.env.VITE_ANTHROPIC_API_KEY,
  dangerouslyAllowBrowser: true,
});

export default claude;